
import {Toast} from 'vant'
import listEmpty from '@/components/list_empty.vue';
import Header from '@/components/header/header.vue'
import WishLsit from '@/components/goods/wish-list.vue' 
import {  inject, reactive,ref, toRefs, isReactive } from 'vue'
import { useRouter } from 'vue-router'
import { getCart } from "@/hooks/index";
export default { 
  components:{
    Header,
    WishLsit,
    listEmpty
  },
 setup() {
    const $http:any = inject('$http')
    const $store:any = inject('$store')
      const router = useRouter()
    
     const product = reactive({
        size:10,
        page:11,
        total :500,      
    })
    const finished = ref(false)
    const loading = ref(false)
    const onLoad = async ()=>{   
      get_favorite_list()
      }
    interface GoodsInfo {
        goods_id?:number
        promotion_price?:string,
        marketprice?:string,
        name?:string,
        goods_image_url?:string,
        price_market?:string
    }
     interface Goods {
        goods_id?:object
       
    }
    let historyData:any= reactive({
      goods:[...$store.getWishList()]
    })
    const cart_list = ref([])
    // 购物车数量
      getCart().then((ret) => {
        cart_list.value = ret
      })
    const get_favorite_list = async ()=>{
 
      if($store.getWishList().length>=100){
             
                 const res = await $http.get_favorite_list({
               size:product.size,
               page:product.page,
           })
            loading.value = true 
        if(res.code === 200){
          product.page += 1
          let goodObj:Array<GoodsInfo> = reactive([])
             res.data.forEach((item:any) => {
              goodObj.push({
                    goods_id:item.goods&&item.goods.goods_id,
                    goods_image_url:item.goods&&item.goods.image,
                    name:item.goods&&item.goods.title,
                    promotion_price:item.goods&&item.goods.price,
                    marketprice:item.goods&&item.goods.price_market,
                  })
            });
            historyData.goods = historyData.goods.concat(goodObj)
            if(res.data.length < product.size){
                   finished.value = true
             }  
            loading.value = false 
        }  
      }else if($store.getWishList().length==100){

      } else{
         loading.value = false 
           finished.value = true
      }      
      
      }
      //添加 删除按钮
      
       interface stateObj {
          type:string,
          goods_id:any
        }
        const beforeClose = async (state:any) => { 
          if( state.type == 'delete') {
            const res = await $http.delete_favorite_goods({
              action: "delete",
              fav_id: state.goods_id,
              fav_type: "goods"
            })
            if(res.code == 200) {
                Toast(res.message);
                product.page = 1
                // let arr1:any = []
                historyData.goods = []
                get_favorite_list()
                  $store.getWishList().splice(state.index,1)
                 historyData.goods = [...$store.getWishList()]
            }
          } else {
            // 跳转 商详页
          router.push('')             
          }
          //type判断是删除还是加购,goods_id为当前id         
        }

      return {
        beforeClose,
        historyData,
        loading,
        finished,
        onLoad,
        cart_list
      }
 }
} 
